import React, { PureComponent } from "react";


import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';


import AssignmentIcon from "@material-ui/icons/Assignment";
import CameraIcon from "@material-ui/icons/Camera";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import GroupIcon from "@material-ui/icons/Group";
import VideocamIcon from "@material-ui/icons/Videocam";
import ViewListIcon from "@material-ui/icons/ViewList";
import DashboardIcon from "@material-ui/icons/Dashboard";
import BurstModeIcon from '@material-ui/icons/BurstMode';
// import BusinessIcon from "@material-ui/icons/Business";

import withStyles from "@material-ui/styles/withStyles";
import classNames from "classnames";

const drawerWidth = 240;

const styles = theme => ({
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    overflow: "hidden"
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9)
    }
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    ...theme.mixins.toolbar
  }
});

class AdminDrawer extends PureComponent {
  render() {
    const { classes } = this.props;
    const { pathname } = this.props.history.location;

    const mainListItems = (
      <div>
        <ListItem button onClick={() => this.props.history.push("/dashboard")}>
          <ListItemIcon>
            {this.props.open ? (
              <DashboardIcon color={pathname === "/dashboard" ? "primary" : "inherit"} />
            ) : (
              <Tooltip title="Dashboard" placement="right">
                <DashboardIcon color={pathname === "/dashboard" ? "primary" : "inherit"} />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText primary="Dashboard" primaryTypographyProps={{ variant: "subtitle1" }} />
        </ListItem>
        <ListItem button onClick={() => this.props.history.push("/accounts")}>
          <ListItemIcon>
            {this.props.open ? (
              <GroupIcon color={pathname === "/accounts" ? "primary" : "inherit"} />
            ) : (
              <Tooltip title="Accounts" placement="right">
                <GroupIcon color={pathname === "/accounts" ? "primary" : "inherit"} />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText primary="Accounts" primaryTypographyProps={{ variant: "subtitle1" }} />
        </ListItem>
        {/* <ListItem button onClick={() => this.props.history.push("/companies")} className={pathname === "/companies" ? "active-nav" : ""}>
          <ListItemIcon>
            {this.props.open ? (
              <BusinessIcon />
            ) : (
              <Tooltip title="Companies" placement="right">
                <BusinessIcon />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText primary="Companies" primaryTypographyProps={{ variant: "subtitle1" }} />
        </ListItem> */}
        <ListItem button onClick={() => this.props.history.push("/shoots")}>
          <ListItemIcon>
            {this.props.open ? (
              <AssignmentIcon color={pathname === "/shoots" || pathname === "/shoots/create" ? "primary" : "inherit"} />
            ) : (
              <Tooltip title="Shoots" placement="right">
                <AssignmentIcon color={pathname === "/shoots" || pathname === "/shoots/create" ? "primary" : "inherit"} />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText primary="Shoots" primaryTypographyProps={{ variant: "subtitle1" }} />
        </ListItem>
        <ListItem button onClick={() => this.props.history.push("/shots/photo")}>
          <ListItemIcon>
            {this.props.open ? (
              <CameraIcon color={pathname === "/shots/photo" ? "primary" : "inherit"} />
            ) : (
              <Tooltip title="Photo Shots" placement="right">
                <CameraIcon color={pathname === "/shots/photo" ? "primary" : "inherit"} />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText primary="Photo Shots" primaryTypographyProps={{ variant: "subtitle1" }} />
        </ListItem>
        <ListItem button onClick={() => this.props.history.push("/shots/video")}>
          <ListItemIcon>
            {this.props.open ? (
              <VideocamIcon color={pathname === "/shots/video" ? "primary" : "inherit"} />
            ) : (
              <Tooltip title="Video Shots" placement="right">
                <VideocamIcon color={pathname === "/shots/video" ? "primary" : "inherit"} />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText primary="Video Shots" primaryTypographyProps={{ variant: "subtitle1" }} />
        </ListItem>
        <ListItem button onClick={() => this.props.history.push("/questions")}>
          <ListItemIcon>
            {this.props.open ? (
              <ViewListIcon color={pathname === "/questions" ? "primary" : "inherit"} />
            ) : (
              <Tooltip title="Question List" placement="right">
                <ViewListIcon color={pathname === "/questions" ? "primary" : "inherit"} />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText primary="Question List" primaryTypographyProps={{ variant: "subtitle1" }} />
        </ListItem>
        <ListItem button onClick={() => this.props.history.push("/packages")}>
          <ListItemIcon>
            {this.props.open ? (
              <BurstModeIcon color={pathname === "/packages" ? "primary" : "inherit"} />
            ) : (
              <Tooltip title="Packages" placement="right">
                <BurstModeIcon color={pathname === "/packages" ? "primary" : "inherit"} />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText primary="Packages" primaryTypographyProps={{ variant: "subtitle1" }} />
        </ListItem>
      </div>
    );

    return (
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(classes.drawerPaper, !this.props.open && classes.drawerPaperClose)
        }}
        open={this.props.open}
      >
        
        <div className={classes.toolbarIcon}>
        <Typography
            component="h1"
            variant="h6"
            color="primary"
            noWrap
            style={{flexGrow: 1}}
          >
            <b>DentistFind</b>
          </Typography>
          {/* <img src={Logo} style={{ width: "20%", height: "20%",float:'left' }} /> */}
          <IconButton onClick={this.props.handleDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>{mainListItems}</List>
        {/* <Divider />
        {this.props.open ? (
          <Grid container justify="center">
            <h5 style={{ position: "fixed", bottom: 0, color: "#636e72" }}>
              &copy; DentistFind Inc.
            </h5>
          </Grid>
        ) : (
          ""
        )} */}
      </Drawer>
    );
  }
}

export default withStyles(styles)(AdminDrawer);
